export enum ENV_BUILD {
    EXCEEDERS = 0,
    STEMEXE,
    EBUILD,
    WELLNEXE
}

export const environment = {
    build: ENV_BUILD.STEMEXE,
    apiHost: "https://idenediapi-prod-stag.azurewebsites.net",
    enableGroupsSelection: true,
    idenediGroupId: "GPI2018101700",
    defaultLocale: 'en',
    customDomainFallbackUrl: 'https://exceeders-app-staging.web.app',
    singleGroupApp: false,

    //new properties
    legacyDeploymentBaseUrl: 'https://stemexe-stag.web.app',
    legacyDeploymentChooseGroup: '/groups/choose',
    productContactFormWidgetUrl:"https://leadlineprodev.azurewebsites.net/static/component/v1.8.0.js",
    //TODO 20June
    authClientId: "idenedi_web_client",
    authClientSecret: "7x63u81880lnfyk", 
    firebase: {
    apiKey: "AIzaSyBS3DQu9Lv3WzgBqCm_ADL-kTHgoW8n-xc",
    authDomain: "stemexe-stag.firebaseapp.com",
    databaseURL: "https://stemexe-stag.firebaseio.com",
    projectId: "stemexe-stag",
    storageBucket: "stemexe-stag.appspot.com",
    messagingSenderId: "73899552612",
    appId: "1:73899552612:web:2eca510063233a23eb1471",
    measurementId: "G-13T4JEWXYF",
    dynamicLink: {
      domainUriPrefix: "https://stemexestag.page.link",
      androidPackageName: "com.exceeders.stemexe.staging",
      iosBundleId: "com.exceeders.stemeXe.Staging"
    }
  },
};
